import {inject, Injectable} from "@angular/core";
import {ActivationEnd, Event, Router,} from "@angular/router";
import {BehaviorSubject, Observable} from "rxjs";

export interface Content {
  title: string;
  subtitle: string;
  showBackButton: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private readonly router: Router = inject(Router);
  private readonly headerContent: BehaviorSubject<Content> = new BehaviorSubject<Content>({
    title: '',
    subtitle: '',
    showBackButton: false
  });
  private manualMode: boolean = false;

  constructor() {
    this.router.events.subscribe((event: Event) => {
      if (this.manualMode) {
        this.manualMode = false;
        return;
      }
      if (event instanceof ActivationEnd && Object.values(event.snapshot.data).length > 0) {
        const currentContent: Content = this.headerContent.getValue();

        let showBackupButton: boolean = false;
        if (event.snapshot.data['showBackButton'] !== undefined) {
          showBackupButton = event.snapshot.data['showBackButton'];
        }

        const newContent: Content = {
          title: event.snapshot.data['title'] ?? currentContent.title,
          subtitle: event.snapshot.data['subtitle'] ?? currentContent.subtitle,
          showBackButton: showBackupButton
        };

        this.headerContent.next(newContent);
      }
    });
  }

  public content(): Observable<Content> {
    return this.headerContent.asObservable();
  }

  public set(param: Content): void {
    this.headerContent.next(param);
    this.manualMode = true;
  }
}
